import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import DatePicker from "../../../../../../common/datePicker";
import { convertDigitToEnglish } from "./../../../../../../method/convertDigitToEnglish";


let useStyles = makeStyles((theme) => ({
    root: {
        width: "270px",
        marginRight: '9%',
        [theme.breakpoints.down("950")]: {
            minWidth: '48%',
        },
        [theme.breakpoints.down("700")]: {
            width: '100%',
            marginRight: 0,
        },
    },
    box: {
        // margin: 10,
        [theme.breakpoints.down("700")]: {
            margin: '10px 0px',
            width: '100%',
        },
    }
}))

export default function Index({ handleChange, state }) {

    let classes = useStyles();


    const handelChangeDate = (data, type) => {

        if (!data) {
            handleChange(null, type)
            return
        }

        let date = convertDigitToEnglish(data?.format("YYYY/MM/DD"));
        date = `${date} 00:00:00.000000`;

        handleChange(date, type)

    };

    return (
        <div className={classes['root']}>
            <Box
                className={classes['box']}
                // marginBottom="30px"
                width="100%"
                height="50px"
            >
                <DatePicker
                    label="از تاریخ"
                    required={true}
                    value={
                        state?.['from_date']?.includes("undefined")
                            ? null
                            : state?.['from_date']
                    }
                    setValue={(data) => handelChangeDate(data, "from_date")}
                />
            </Box>
        </div>
    )
}



